const projectTypes = [
    "Web Application Development",
    "Mobile App Development",
    "E-commerce Solution",
    "Maintenance & Support",
    "Enterprise System",
    "Digital Transformation",
    "System Integration",
    "API Development",
    "Other"
];

export default projectTypes;